import { Noto_Sans_JP, Noto_Sans_KR, Noto_Sans_SC, Noto_Sans_TC } from 'next/font/google'
import localFont from 'next/font/local'

import type { Language } from '@/shared/lib/i18n'

export const sourceSansPro = localFont({
    src: [
        { path: './font-files/SourceSansPro-ExtraLight.woff2', weight: '200', style: 'normal' },
        { path: './font-files/SourceSansPro-Light.woff2', weight: '300', style: 'normal' },
        { path: './font-files/SourceSansPro-Regular.woff2', weight: '400', style: 'normal' },
        { path: './font-files/SourceSansPro-Semibold.woff2', weight: '500', style: 'normal' },
        { path: './font-files/SourceSansPro-Bold.woff2', weight: '700', style: 'normal' },
        { path: './font-files/SourceSansPro-Black.woff2', weight: '900', style: 'normal' },
    ],
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

export const montserrat = localFont({
    src: [
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-100.woff2',
            weight: '100',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-100italic.woff2',
            weight: '100',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-200.woff2',
            weight: '200',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-200italic.woff2',
            weight: '200',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-300.woff2',
            weight: '300',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-300italic.woff2',
            weight: '300',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-regular.woff2',
            weight: '400',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-italic.woff2',
            weight: '400',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-500.woff2',
            weight: '500',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-500italic.woff2',
            weight: '500',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-600.woff2',
            weight: '600',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-600italic.woff2',
            weight: '600',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-700.woff2',
            weight: '700',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-700italic.woff2',
            weight: '700',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-800.woff2',
            weight: '800',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-800italic.woff2',
            weight: '800',
            style: 'italic',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-900.woff2',
            weight: '900',
            style: 'normal',
        },
        {
            path: './font-files/montserrat-v12-latin-ext_latin_cyrillic-900italic.woff2',
            weight: '900',
            style: 'italic',
        },
    ],
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

export const notoSans = localFont({
    src: [
        { path: './font-files/NotoSans-100.woff2', weight: '100', style: 'normal' },
        { path: './font-files/NotoSans-200.woff2', weight: '200', style: 'normal' },
        { path: './font-files/NotoSans-300.woff2', weight: '300', style: 'normal' },
        { path: './font-files/NotoSans-400.woff2', weight: '400', style: 'normal' },
        { path: './font-files/NotoSans-500.woff2', weight: '500', style: 'normal' },
        { path: './font-files/NotoSans-600.woff2', weight: '600', style: 'normal' },
        { path: './font-files/NotoSans-700.woff2', weight: '700', style: 'normal' },
        { path: './font-files/NotoSans-800.woff2', weight: '800', style: 'normal' },
        { path: './font-files/NotoSans-900.woff2', weight: '900', style: 'normal' },
    ],
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

// Downloaded at build time instead of stored in the repo: Google serves the CJK families as
// unicode-range slices, so a CJK visitor fetches the few slices a page needs rather than one
// multi-megabyte file per weight. `weight` is omitted to get the variable font.
// Unlike the local fonts above, these do not set `adjustFontFallback: false`: Turbopack ignores
// that option on next/font/google (Next 16.3.3) and emits the metric-adjusted Arial fallback
// regardless, so the default keeps the source in step with the build output.
export const notoSansJP = Noto_Sans_JP({
    display: 'swap',
    preload: false,
})

export const notoSansKR = Noto_Sans_KR({
    display: 'swap',
    preload: false,
})

export const notoSansSC = Noto_Sans_SC({
    display: 'swap',
    preload: false,
})

export const notoSansTC = Noto_Sans_TC({
    display: 'swap',
    preload: false,
})

type FontModule = {
    style: {
        fontFamily: string
    }
}

export type FontTheme = {
    sourceSansPro: string
    notoSans: string
    montserrat: string
}

const systemSansSerifFallback = `
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji'
`

function createFontFamilyValue(font: FontModule) {
    return `${font.style.fontFamily}, ${systemSansSerifFallback}`
}

// CJK locales replace every font with their Noto variant — the latin fonts have no glyph coverage there.
const localeFontByLanguage: Partial<Record<Language, FontModule>> = {
    ja: notoSansJP,
    ko: notoSansKR,
    cn: notoSansSC,
    tw: notoSansTC,
}

const defaultFontTheme: FontTheme = {
    sourceSansPro: createFontFamilyValue(sourceSansPro),
    notoSans: createFontFamilyValue(notoSans),
    montserrat: createFontFamilyValue(montserrat),
}

export function getLocaleFont(lang: Language): FontModule | undefined {
    return localeFontByLanguage[lang]
}

export function getFontTheme(lang: Language): FontTheme {
    const localeFont = localeFontByLanguage[lang]
    if (!localeFont) {
        return defaultFontTheme
    }

    const localeFontFamily = createFontFamilyValue(localeFont)

    return {
        sourceSansPro: localeFontFamily,
        notoSans: localeFontFamily,
        montserrat: localeFontFamily,
    }
}
